import React from 'react';
import colors from '../../utils/colors';
import SkillIcon from './SkillIcon';
import { Badge } from '../ui-kit';

const warningStatusOperand = {
  below_required: '<',
  on_required: '=',
  on_buffer: '>',
  below_buffer: '>',
  above_buffer: '>'
};

// Show the availability requirements with required level, current level
// and skill icon
// TODO: use the AvailabilityRequirementStatus instead. Needs skills to be
// passed
const IncidentWarning = props => {
  let skillStatuses = props.warningStatus.skill_statuses;
  skillStatuses = skillStatuses || [];
  if (props.onlyShowUnderstaffed) skillStatuses = skillStatuses.filter(ss => ss.level === 'below_required');

  return (
    <div className="d-inline-block">
      {skillStatuses.map((status, index) => (
        <Badge className="m-1" color={colors[status.level]} key={index}>
          <SkillIcon skill={props.skills.byId[status.skill_id]} /> {status.assigned_count}{' '}
          {warningStatusOperand[status.level]} {status.minimum}
        </Badge>
      ))}
    </div>
  );
};

export default IncidentWarning;
